<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 32"
    :style="
      `max-width: ${size}px; ${
        autoMargin ? `margin-left: auto; margin-right: auto;` : ''
      } width: 100%;`
    "
  >
    <rect x="19" y="18" width="14" height="3" :fill="fill" />
    <path
      :fill="fill"
      d="M35.12,0H4.88A5,5,0,0,0,0,5.14V26.86A5,5,0,0,0,4.88,32H35.12A5,5,0,0,0,40,26.86V5.14A5,5,0,0,0,35.12,0ZM13,18.79H5V16h8Zm0-4.65H5V11.35h8Zm0-4.65H5V6.7h8Zm22,18.6H17V3.91H35Z"
    />
    <rect x="19" y="8" width="14" height="3" :fill="fill" />
    <rect x="19" y="13" width="14" height="3" :fill="fill" />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      default: 28
    },
    fill: {
      default: '#eee'
    },
    autoMargin: {
      default: true
    }
  }
};
</script>

<style></style>
